import gsap from 'gsap';

const inner = document.querySelector('.js-geo-inner');

function geoIsInViewInit() {
    if (inner) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('is-in-view');
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                rootMargin: '-25% 0% -25% 0%',
                threshold: 0,
            },
        );
        observer.observe(inner);
    }
}

function geoStickyInit() {
    if (inner) {
        gsap.set(inner, {
            y: () => -window.innerHeight,
        });
        gsap.to(inner, {
            scrollTrigger: {
                trigger: inner,
                start: '0% 0%',
                end: () => '+=' + window.innerHeight,
                scrub: 0,
                invalidateOnRefresh: true,
                onLeave: () => inner.classList.add('is-in-view'),
            },
            y: 0,
            ease: 'none',
        });
    }
}

function geoInit() {
    geoIsInViewInit();
    geoStickyInit();
}

function init() {
    geoInit();
}

const _module = { init };

export default _module;
